import {
  userSubscriptionOffers,
  userSubscriptionOffers_offers,
  userTokensOffers_offers,
} from "../Api/types";
import { api_postValueOrErrorMessage } from "../Api/util";
import { PLATFORM } from "../Hook/platform";
import { USER } from "../Hook/user";
let debug: any;
let shift4ComponentGroup: any = null;

export const registerShift4ComponentGroup = (componentGroup: any) => {
  shift4ComponentGroup = componentGroup;
};

export const unregisterShift4ComponentGroup = () => {
  if (shift4ComponentGroup) {
    shift4ComponentGroup = null;
  }
};
export const FormatPrice = ({
  price,
  currency,
}: {
  price: number;
  currency: string;
}) => {
  const symbol = currencies[currency.toUpperCase()]?.symbol;
  if (currency === "eur") {
    return (
      <>
        <div>{price}</div>
        <div>{symbol ?? currency}</div>
      </>
    );
  }
  return (
    <>
      <div>{symbol ?? currency}</div>
      <div>{price}</div>
    </>
  );
};

export function getBase64(file: File | Blob) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
}

export const handleShift4subTransaction = async (
  offer: userSubscriptionOffers_offers,
  cardIndex: number,
  callback: (error?: string, addData?: any) => any,
  newCard?: boolean,
) => {
  const Shift4 = PLATFORM.paymentprocessor;
  if (!newCard) {
    let token: any = await call3DSecureCheck(
      offer.price,
      offer.currency,
      USER.cards[cardIndex].card_id,
      Shift4,
    );
    if (token.error) return callback(token);
    let payload = { card_token: token.id, offer: offer.id };
    callback(
      await api_postValueOrErrorMessage(
        "user/subscription/request_bill",
        payload,
      ),
    );
  } else {
    let card: cardTokenCreate = (await createNewCardToken(Shift4)) as any;
    if (card.error && typeof card.error === "object")
      return callback({ ...card as any, ...debug as any, offer: offer.id });
    let token: any = await call3DSecureCheck(
      offer.price,
      offer.currency,
      card.id,
      Shift4,
    );
    if (token.error) return callback(token);
    let payload = { card_token: token.id, offer: offer.id };
    callback(
      await api_postValueOrErrorMessage(
        "user/subscription/request_bill",
        payload,
      ),
      { ...card as any, ...debug as any, offer: offer, payload }
    );
  }
};

export const handleShift4TokenTransaction = async (
  offer: userTokensOffers_offers,
  cardIndex: number,
  callback: (error?: string) => any,
  newCard?: boolean,
) => {
  const Shift4 = PLATFORM.paymentprocessor;
  if (!newCard) {
    let token: any = await call3DSecureCheck(
      offer.price,
      offer.currency,
      USER.cards[cardIndex].card_id,
      Shift4,
    );
    if (token.error) return callback(token);
    let payload = { card_token: token.id, offer: offer.id };
    callback(
      await api_postValueOrErrorMessage("user/tokens/request_bill", payload),
    );
  } else {
    let card: cardTokenCreate = (await createNewCardToken(Shift4)) as any;
    if (card.error && typeof card.error === "object")
      return callback({ ...card as any, ...debug as any, offer });
    try {
      let token: any = await call3DSecureCheck(
        offer.price,
        offer.currency,
        card.id,
        Shift4,
      );
      if (token.error) return callback(token);
      let payload = { card_token: token.id, offer: offer.id };
      callback(
        await api_postValueOrErrorMessage("user/tokens/request_bill", payload),
      );
    }catch(err){
      callback(err as any)
      console.error(err);
    }
    
  }
};

const call3DSecureCheck = (
  amount: number,
  currency: string,
  card: string,
  Shift4: any,
) => {
  return new Promise((resolve, reject) => {
    Shift4.verifyThreeDSecure(
      {
        amount: amount * 100,
        currency: currency.toUpperCase(),
        card: card,
      }
    ).then(resolve).catch(reject);
  })
};

interface cardTokenCreate {
  error: {
    code: string;
  };
  id: string;
}

export const createNewCardToken = (Shift4: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    if (!shift4ComponentGroup) {
      return reject({ error: "no_component_group" });
    }

    var additionalFields = {
				cardholderName: (document.getElementById("cardholderName") as HTMLInputElement)?.value,
				fraudCheckData: {
					email: USER.informations!.email
				}
			};

    // Use the component group to create a token
    // The component group handles secure collection of card data
    Shift4.createToken(
      shift4ComponentGroup,
      additionalFields
    )
    .then((response: any) => {
      debug = { email: USER.informations!.email };
      resolve(response);
    })
    .catch((error: any) => {
      debug = { email: USER.informations!.email, error };
      reject(error);
    });
  });
};

const currencies: any = {
  AED: {
    isoCode: "784",
    fractionDigit: 2,
    currencyName: "UAE Dirham",
    countries: ["United Arab Emirates (The)"],
  },
  AFN: {
    isoCode: "971",
    fractionDigit: 2,
    currencyName: "Afghani",
    countries: ["Afghanistan"],
  },
  ALL: {
    isoCode: "008",
    fractionDigit: 2,
    currencyName: "Lek",
    countries: ["Albania"],
  },
  AMD: {
    isoCode: "051",
    fractionDigit: 2,
    currencyName: "Armenian Dram",
    countries: ["Armenia"],
  },
  ANG: {
    isoCode: "532",
    fractionDigit: 2,
    currencyName: "Netherlands Antillean Guilder",
    countries: ["Curaçao", "Sint Maarten (Dutch Part)"],
  },
  AOA: {
    isoCode: "973",
    fractionDigit: 2,
    currencyName: "Kwanza",
    countries: ["Angola"],
  },
  ARS: {
    isoCode: "032",
    fractionDigit: 2,
    currencyName: "Argentine Peso",
    countries: ["Argentina"],
  },
  AUD: {
    isoCode: "036",
    fractionDigit: 2,
    currencyName: "Australian Dollar",
    countries: [
      "Australia",
      "Christmas Island",
      "Cocos (Keeling) Islands (The)",
      "Heard Island and Mcdonald Islands",
      "Kiribati",
      "Nauru",
      "Norfolk Island",
      "Tuvalu",
    ],
  },
  AWG: {
    isoCode: "533",
    fractionDigit: 2,
    currencyName: "Aruban Florin",
    countries: ["Aruba"],
  },
  AZN: {
    isoCode: "944",
    fractionDigit: 2,
    currencyName: "Azerbaijan Manat",
    countries: ["Azerbaijan"],
  },
  BAM: {
    isoCode: "977",
    fractionDigit: 2,
    currencyName: "Convertible Mark",
    countries: ["Bosnia and Herzegovina"],
  },
  BBD: {
    isoCode: "052",
    fractionDigit: 2,
    currencyName: "Barbados Dollar",
    countries: ["Barbados"],
  },
  BDT: {
    isoCode: "050",
    fractionDigit: 2,
    currencyName: "Taka",
    countries: ["Bangladesh"],
  },
  BGN: {
    isoCode: "975",
    fractionDigit: 2,
    symbol: "лв",
    unicode: "лв",
    htmlCode: "лв",
    hexCode: "лв",
    currencyName: "Bulgarian Lev",
    countries: ["Bulgaria"],
  },
  BHD: {
    isoCode: "048",
    fractionDigit: 3,
    currencyName: "Bahraini Dinar",
    countries: ["Bahrain"],
  },
  BIF: {
    isoCode: "108",
    fractionDigit: 0,
    currencyName: "Burundi Franc",
    countries: ["Burundi"],
  },
  BMD: {
    isoCode: "060",
    fractionDigit: 2,
    currencyName: "Bermudian Dollar",
    countries: ["Bermuda"],
  },
  BND: {
    isoCode: "096",
    fractionDigit: 2,
    currencyName: "Brunei Dollar",
    countries: ["Brunei Darussalam"],
  },
  BOB: {
    isoCode: "068",
    fractionDigit: 2,
    currencyName: "Boliviano",
    countries: ["Bolivia (Plurinational State Of)"],
  },
  BOV: {
    isoCode: "984",
    fractionDigit: 2,
    currencyName: "Mvdol",
    countries: ["Bolivia (Plurinational State Of)"],
  },
  BRL: {
    isoCode: "986",
    fractionDigit: 2,
    currencyName: "Brazilian Real",
    countries: ["Brazil"],
  },
  BSD: {
    isoCode: "044",
    fractionDigit: 2,
    currencyName: "Bahamian Dollar",
    countries: ["Bahamas (The)"],
  },
  BTN: {
    isoCode: "064",
    fractionDigit: 2,
    currencyName: "Ngultrum",
    countries: ["Bhutan"],
  },
  BWP: {
    isoCode: "072",
    fractionDigit: 2,
    currencyName: "Pula",
    countries: ["Botswana"],
  },
  BYN: {
    isoCode: "933",
    fractionDigit: 2,
    currencyName: "Belarusian Ruble",
    countries: ["Belarus"],
  },
  BZD: {
    isoCode: "084",
    fractionDigit: 2,
    currencyName: "Belize Dollar",
    countries: ["Belize"],
  },
  CAD: {
    isoCode: "124",
    fractionDigit: 2,
    currencyName: "Canadian Dollar",
    countries: ["Canada"],
  },
  CDF: {
    isoCode: "976",
    fractionDigit: 2,
    currencyName: "Congolese Franc",
    countries: ["Congo (The Democratic Republic of The)"],
  },
  CHE: {
    isoCode: "947",
    fractionDigit: 2,
    currencyName: "WIR Euro",
    countries: ["Switzerland"],
  },
  CHF: {
    isoCode: "756",
    fractionDigit: 2,
    symbol: "CHF",
    unicode: "CHF",
    htmlCode: "CHF",
    hexCode: "CHF",
    currencyName: "Swiss Franc",
    countries: ["Liechtenstein", "Switzerland"],
  },
  CHW: {
    isoCode: "948",
    fractionDigit: 2,
    currencyName: "WIR Franc",
    countries: ["Switzerland"],
  },
  CLF: {
    isoCode: "990",
    fractionDigit: 4,
    currencyName: "Unidad de Fomento",
    countries: ["Chile"],
  },
  CLP: {
    isoCode: "152",
    fractionDigit: 0,
    currencyName: "Chilean Peso",
    countries: ["Chile"],
  },
  CNY: {
    isoCode: "156",
    fractionDigit: 2,
    currencyName: "Yuan Renminbi",
    countries: ["China"],
  },
  COP: {
    isoCode: "170",
    fractionDigit: 2,
    currencyName: "Colombian Peso",
    countries: ["Colombia"],
  },
  COU: {
    isoCode: "970",
    fractionDigit: 2,
    currencyName: "Unidad de Valor Real",
    countries: ["Colombia"],
  },
  CRC: {
    isoCode: "188",
    fractionDigit: 2,
    currencyName: "Costa Rican Colon",
    countries: ["Costa Rica"],
  },
  CUC: {
    isoCode: "931",
    fractionDigit: 2,
    currencyName: "Peso Convertible",
    countries: ["Cuba"],
  },
  CUP: {
    isoCode: "192",
    fractionDigit: 2,
    currencyName: "Cuban Peso",
    countries: ["Cuba"],
  },
  CVE: {
    isoCode: "132",
    fractionDigit: 2,
    currencyName: "Cabo Verde Escudo",
    countries: ["Cabo Verde"],
  },
  CZK: {
    isoCode: "203",
    fractionDigit: 2,
    symbol: "Kč",
    unicode: "Kč",
    htmlCode: "Kč",
    hexCode: "Kč",
    currencyName: "Czech Koruna",
    countries: ["Czechia"],
  },
  DJF: {
    isoCode: "262",
    fractionDigit: 0,
    currencyName: "Djibouti Franc",
    countries: ["Djibouti"],
  },
  DKK: {
    isoCode: "208",
    fractionDigit: 2,
    symbol: "kr",
    unicode: "kr",
    htmlCode: "kr",
    hexCode: "kr",
    currencyName: "Danish Krone",
    countries: ["Denmark", "Faroe Islands (The)", "Greenland"],
  },
  DOP: {
    isoCode: "214",
    fractionDigit: 2,
    currencyName: "Dominican Peso",
    countries: ["Dominican Republic (The)"],
  },
  DZD: {
    isoCode: "012",
    fractionDigit: 2,
    currencyName: "Algerian Dinar",
    countries: ["Algeria"],
  },
  EGP: {
    isoCode: "818",
    fractionDigit: 2,
    currencyName: "Egyptian Pound",
    countries: ["Egypt"],
  },
  ERN: {
    isoCode: "232",
    fractionDigit: 2,
    currencyName: "Nakfa",
    countries: ["Eritrea"],
  },
  ETB: {
    isoCode: "230",
    fractionDigit: 2,
    currencyName: "Ethiopian Birr",
    countries: ["Ethiopia"],
  },
  EUR: {
    isoCode: "978",
    fractionDigit: 2,
    symbol: "€",
    unicode: "U+020AC",
    htmlCode: "&#x20AC;",
    hexCode: "&#8364;",
    currencyName: "Euro",
    countries: [
      "Åland Islands",
      "Andorra",
      "Austria",
      "Belgium",
      "Cyprus",
      "Estonia",
      "European Union",
      "Finland",
      "France",
      "French Guiana",
      "French Southern Territories (The)",
      "Germany",
      "Greece",
      "Guadeloupe",
      "Holy See (The)",
      "Ireland",
      "Italy",
      "Latvia",
      "Lithuania",
      "Luxembourg",
      "Malta",
      "Martinique",
      "Mayotte",
      "Monaco",
      "Montenegro",
      "Netherlands (The)",
      "Portugal",
      "Réunion",
      "Saint Barthélemy",
      "Saint Martin (French Part)",
      "Saint Pierre and Miquelon",
      "San Marino",
      "Slovakia",
      "Slovenia",
      "Spain",
    ],
  },
  FJD: {
    isoCode: "242",
    fractionDigit: 2,
    currencyName: "Fiji Dollar",
    countries: ["Fiji"],
  },
  FKP: {
    isoCode: "238",
    fractionDigit: 2,
    currencyName: "Falkland Islands Pound",
    countries: ["Falkland Islands (The) [Malvinas]"],
  },
  GBP: {
    isoCode: "826",
    fractionDigit: 2,
    symbol: "£",
    unicode: "U+000A3",
    htmlCode: "&#xA3;",
    hexCode: "&#163;",
    currencyName: "Pound Sterling",
    countries: [
      "Guernsey",
      "Isle of Man",
      "Jersey",
      "United Kingdom of Great Britain and Northern Ireland (The)",
    ],
  },
  GEL: {
    isoCode: "981",
    fractionDigit: 2,
    symbol: "₾",
    unicode: "U+20BE",
    htmlCode: "&#x20BE;",
    hexCode: "&#8382;",
    currencyName: "Lari",
    countries: ["Georgia"],
  },
  GHS: {
    isoCode: "936",
    fractionDigit: 2,
    currencyName: "Ghana Cedi",
    countries: ["Ghana"],
  },
  GIP: {
    isoCode: "292",
    fractionDigit: 2,
    currencyName: "Gibraltar Pound",
    countries: ["Gibraltar"],
  },
  GMD: {
    isoCode: "270",
    fractionDigit: 2,
    currencyName: "Dalasi",
    countries: ["Gambia (The)"],
  },
  GNF: {
    isoCode: "324",
    fractionDigit: 0,
    currencyName: "Guinean Franc",
    countries: ["Guinea"],
  },
  GTQ: {
    isoCode: "320",
    fractionDigit: 2,
    currencyName: "Quetzal",
    countries: ["Guatemala"],
  },
  GYD: {
    isoCode: "328",
    fractionDigit: 2,
    currencyName: "Guyana Dollar",
    countries: ["Guyana"],
  },
  HKD: {
    isoCode: "344",
    fractionDigit: 2,
    currencyName: "Hong Kong Dollar",
    countries: ["Hong Kong"],
  },
  HNL: {
    isoCode: "340",
    fractionDigit: 2,
    currencyName: "Lempira",
    countries: ["Honduras"],
  },
  HRK: {
    isoCode: "191",
    fractionDigit: 2,
    symbol: "kn",
    unicode: "kn",
    htmlCode: "kn",
    hexCode: "kn",
    currencyName: "Kuna",
    countries: ["Croatia"],
  },
  HTG: {
    isoCode: "332",
    fractionDigit: 2,
    currencyName: "Gourde",
    countries: ["Haiti"],
  },
  HUF: {
    isoCode: "348",
    fractionDigit: 2,
    currencyName: "Forint",
    countries: ["Hungary"],
  },
  IDR: {
    isoCode: "360",
    fractionDigit: 2,
    currencyName: "Rupiah",
    countries: ["Indonesia"],
  },
  ILS: {
    isoCode: "376",
    fractionDigit: 2,
    currencyName: "New Israeli Sheqel",
    countries: ["Israel"],
  },
  INR: {
    isoCode: "356",
    fractionDigit: 2,
    symbol: "₹",
    unicode: "U+020B9",
    htmlCode: "&#x20B9;",
    hexCode: "&#8377;",
    currencyName: "Indian Rupee",
    countries: ["Bhutan", "India"],
  },
  IQD: {
    isoCode: "368",
    fractionDigit: 3,
    currencyName: "Iraqi Dinar",
    countries: ["Iraq"],
  },
  IRR: {
    isoCode: "364",
    fractionDigit: 2,
    currencyName: "Iranian Rial",
    countries: ["Iran (Islamic Republic Of)"],
  },
  ISK: {
    isoCode: "352",
    fractionDigit: 0,
    currencyName: "Iceland Krona",
    countries: ["Iceland"],
  },
  JMD: {
    isoCode: "388",
    fractionDigit: 2,
    currencyName: "Jamaican Dollar",
    countries: ["Jamaica"],
  },
  JOD: {
    isoCode: "400",
    fractionDigit: 3,
    currencyName: "Jordanian Dinar",
    countries: ["Jordan"],
  },
  JPY: {
    isoCode: "392",
    fractionDigit: 0,
    symbol: "¥",
    unicode: "U+000A5",
    htmlCode: "&#xa5;",
    hexCode: "&#165;",
    currencyName: "Yen",
    countries: ["Japan"],
  },
  KES: {
    isoCode: "404",
    fractionDigit: 2,
    currencyName: "Kenyan Shilling",
    countries: ["Kenya"],
  },
  KGS: {
    isoCode: "417",
    fractionDigit: 2,
    currencyName: "Som",
    countries: ["Kyrgyzstan"],
  },
  KHR: {
    isoCode: "116",
    fractionDigit: 2,
    currencyName: "Riel",
    countries: ["Cambodia"],
  },
  KMF: {
    isoCode: "174",
    fractionDigit: 0,
    currencyName: "Comorian Franc ",
    countries: ["Comoros (The)"],
  },
  KPW: {
    isoCode: "408",
    fractionDigit: 2,
    currencyName: "North Korean Won",
    countries: ["Korea (The Democratic People’s Republic Of)"],
  },
  KRW: {
    isoCode: "410",
    fractionDigit: 0,
    currencyName: "Won",
    countries: ["Korea (The Republic Of)"],
  },
  KWD: {
    isoCode: "414",
    fractionDigit: 3,
    currencyName: "Kuwaiti Dinar",
    countries: ["Kuwait"],
  },
  KYD: {
    isoCode: "136",
    fractionDigit: 2,
    currencyName: "Cayman Islands Dollar",
    countries: ["Cayman Islands (The)"],
  },
  KZT: {
    isoCode: "398",
    fractionDigit: 2,
    currencyName: "Tenge",
    countries: ["Kazakhstan"],
  },
  LAK: {
    isoCode: "418",
    fractionDigit: 2,
    currencyName: "Lao Kip",
    countries: ["Lao People’s Democratic Republic (The)"],
  },
  LBP: {
    isoCode: "422",
    fractionDigit: 2,
    currencyName: "Lebanese Pound",
    countries: ["Lebanon"],
  },
  LKR: {
    isoCode: "144",
    fractionDigit: 2,
    currencyName: "Sri Lanka Rupee",
    countries: ["Sri Lanka"],
  },
  LRD: {
    isoCode: "430",
    fractionDigit: 2,
    currencyName: "Liberian Dollar",
    countries: ["Liberia"],
  },
  LSL: {
    isoCode: "426",
    fractionDigit: 2,
    currencyName: "Loti",
    countries: ["Lesotho"],
  },
  LYD: {
    isoCode: "434",
    fractionDigit: 3,
    currencyName: "Libyan Dinar",
    countries: ["Libya"],
  },
  MAD: {
    isoCode: "504",
    fractionDigit: 2,
    currencyName: "Moroccan Dirham",
    countries: ["Morocco", "Western Sahara"],
  },
  MDL: {
    isoCode: "498",
    fractionDigit: 2,
    currencyName: "Moldovan Leu",
    countries: ["Moldova (The Republic Of)"],
  },
  MGA: {
    isoCode: "969",
    fractionDigit: 2,
    currencyName: "Malagasy Ariary",
    countries: ["Madagascar"],
  },
  MKD: {
    isoCode: "807",
    fractionDigit: 2,
    currencyName: "Denar",
    countries: ["Macedonia (The Former Yugoslav Republic Of)"],
  },
  MMK: {
    isoCode: "104",
    fractionDigit: 2,
    currencyName: "Kyat",
    countries: ["Myanmar"],
  },
  MNT: {
    isoCode: "496",
    fractionDigit: 2,
    currencyName: "Tugrik",
    countries: ["Mongolia"],
  },
  MOP: {
    isoCode: "446",
    fractionDigit: 2,
    currencyName: "Pataca",
    countries: ["Macao"],
  },
  MRU: {
    isoCode: "929",
    fractionDigit: 2,
    currencyName: "Ouguiya",
    countries: ["Mauritania"],
  },
  MUR: {
    isoCode: "480",
    fractionDigit: 2,
    currencyName: "Mauritius Rupee",
    countries: ["Mauritius"],
  },
  MVR: {
    isoCode: "462",
    fractionDigit: 2,
    currencyName: "Rufiyaa",
    countries: ["Maldives"],
  },
  MWK: {
    isoCode: "454",
    fractionDigit: 2,
    currencyName: "Malawi Kwacha",
    countries: ["Malawi"],
  },
  MXN: {
    isoCode: "484",
    fractionDigit: 2,
    currencyName: "Mexican Peso",
    countries: ["Mexico"],
  },
  MXV: {
    isoCode: "979",
    fractionDigit: 2,
    currencyName: "Mexican Unidad de Inversion (UDI)",
    countries: ["Mexico"],
  },
  MYR: {
    isoCode: "458",
    fractionDigit: 2,
    currencyName: "Malaysian Ringgit",
    countries: ["Malaysia"],
  },
  MZN: {
    isoCode: "943",
    fractionDigit: 2,
    currencyName: "Mozambique Metical",
    countries: ["Mozambique"],
  },
  NAD: {
    isoCode: "516",
    fractionDigit: 2,
    currencyName: "Namibia Dollar",
    countries: ["Namibia"],
  },
  NGN: {
    isoCode: "566",
    fractionDigit: 2,
    currencyName: "Naira",
    countries: ["Nigeria"],
  },
  NIO: {
    isoCode: "558",
    fractionDigit: 2,
    currencyName: "Cordoba Oro",
    countries: ["Nicaragua"],
  },
  NOK: {
    isoCode: "578",
    fractionDigit: 2,
    currencyName: "Norwegian Krone",
    countries: ["Bouvet Island", "Norway", "Svalbard and Jan Mayen"],
  },
  NPR: {
    isoCode: "524",
    fractionDigit: 2,
    currencyName: "Nepalese Rupee",
    countries: ["Nepal"],
  },
  NZD: {
    isoCode: "554",
    fractionDigit: 2,
    currencyName: "New Zealand Dollar",
    countries: [
      "Cook Islands (The)",
      "New Zealand",
      "Niue",
      "Pitcairn",
      "Tokelau",
    ],
  },
  OMR: {
    isoCode: "512",
    fractionDigit: 3,
    currencyName: "Rial Omani",
    countries: ["Oman"],
  },
  PAB: {
    isoCode: "590",
    fractionDigit: 2,
    currencyName: "Balboa",
    countries: ["Panama"],
  },
  PEN: {
    isoCode: "604",
    fractionDigit: 2,
    currencyName: "Sol",
    countries: ["Peru"],
  },
  PGK: {
    isoCode: "598",
    fractionDigit: 2,
    currencyName: "Kina",
    countries: ["Papua New Guinea"],
  },
  PHP: {
    isoCode: "608",
    fractionDigit: 2,
    currencyName: "Philippine Peso",
    countries: ["Philippines (The)"],
  },
  PKR: {
    isoCode: "586",
    fractionDigit: 2,
    currencyName: "Pakistan Rupee",
    countries: ["Pakistan"],
  },
  PLN: {
    isoCode: "985",
    fractionDigit: 2,
    currencyName: "Zloty",
    countries: ["Poland"],
  },
  PYG: {
    isoCode: "600",
    fractionDigit: 0,
    currencyName: "Guarani",
    countries: ["Paraguay"],
  },
  QAR: {
    isoCode: "634",
    fractionDigit: 2,
    currencyName: "Qatari Rial",
    countries: ["Qatar"],
  },
  RON: {
    isoCode: "946",
    fractionDigit: 2,
    currencyName: "Romanian Leu",
    countries: ["Romania"],
  },
  RSD: {
    isoCode: "941",
    fractionDigit: 2,
    currencyName: "Serbian Dinar",
    countries: ["Serbia"],
  },
  RUB: {
    isoCode: "643",
    fractionDigit: 2,
    currencyName: "Russian Ruble",
    countries: ["Russian Federation (The)"],
  },
  RWF: {
    isoCode: "646",
    fractionDigit: 0,
    currencyName: "Rwanda Franc",
    countries: ["Rwanda"],
  },
  SAR: {
    isoCode: "682",
    fractionDigit: 2,
    currencyName: "Saudi Riyal",
    countries: ["Saudi Arabia"],
  },
  SBD: {
    isoCode: "090",
    fractionDigit: 2,
    currencyName: "Solomon Islands Dollar",
    countries: ["Solomon Islands"],
  },
  SCR: {
    isoCode: "690",
    fractionDigit: 2,
    currencyName: "Seychelles Rupee",
    countries: ["Seychelles"],
  },
  SDG: {
    isoCode: "938",
    fractionDigit: 2,
    currencyName: "Sudanese Pound",
    countries: ["Sudan (The)"],
  },
  SEK: {
    isoCode: "752",
    fractionDigit: 2,
    currencyName: "Swedish Krona",
    countries: ["Sweden"],
  },
  SGD: {
    isoCode: "702",
    fractionDigit: 2,
    currencyName: "Singapore Dollar",
    countries: ["Singapore"],
  },
  SHP: {
    isoCode: "654",
    fractionDigit: 2,
    currencyName: "Saint Helena Pound",
    countries: ["Saint Helena, Ascension and Tristan Da Cunha"],
  },
  SLL: {
    isoCode: "694",
    fractionDigit: 2,
    currencyName: "Leone",
    countries: ["Sierra Leone"],
  },
  SOS: {
    isoCode: "706",
    fractionDigit: 2,
    currencyName: "Somali Shilling",
    countries: ["Somalia"],
  },
  SRD: {
    isoCode: "968",
    fractionDigit: 2,
    currencyName: "Surinam Dollar",
    countries: ["Suriname"],
  },
  SSP: {
    isoCode: "728",
    fractionDigit: 2,
    currencyName: "South Sudanese Pound",
    countries: ["South Sudan"],
  },
  STN: {
    isoCode: "930",
    fractionDigit: 2,
    currencyName: "Dobra",
    countries: ["Sao Tome and Principe"],
  },
  SVC: {
    isoCode: "222",
    fractionDigit: 2,
    currencyName: "El Salvador Colon",
    countries: ["El Salvador"],
  },
  SYP: {
    isoCode: "760",
    fractionDigit: 2,
    currencyName: "Syrian Pound",
    countries: ["Syrian Arab Republic"],
  },
  SZL: {
    isoCode: "748",
    fractionDigit: 2,
    currencyName: "Lilangeni",
    countries: ["Eswatini"],
  },
  THB: {
    isoCode: "764",
    fractionDigit: 2,
    currencyName: "Baht",
    countries: ["Thailand"],
  },
  TJS: {
    isoCode: "972",
    fractionDigit: 2,
    currencyName: "Somoni",
    countries: ["Tajikistan"],
  },
  TMT: {
    isoCode: "934",
    fractionDigit: 2,
    currencyName: "Turkmenistan New Manat",
    countries: ["Turkmenistan"],
  },
  TND: {
    isoCode: "788",
    fractionDigit: 3,
    currencyName: "Tunisian Dinar",
    countries: ["Tunisia"],
  },
  TOP: {
    isoCode: "776",
    fractionDigit: 2,
    currencyName: "Pa’anga",
    countries: ["Tonga"],
  },
  TRY: {
    isoCode: "949",
    fractionDigit: 2,
    currencyName: "Turkish Lira",
    countries: ["Turkey"],
  },
  TTD: {
    isoCode: "780",
    fractionDigit: 2,
    currencyName: "Trinidad and Tobago Dollar",
    countries: ["Trinidad and Tobago"],
  },
  TWD: {
    isoCode: "901",
    fractionDigit: 2,
    currencyName: "New Taiwan Dollar",
    countries: ["Taiwan (Province of China)"],
  },
  TZS: {
    isoCode: "834",
    fractionDigit: 2,
    currencyName: "Tanzanian Shilling",
    countries: ["Tanzania, United Republic Of"],
  },
  UAH: {
    isoCode: "980",
    fractionDigit: 2,
    currencyName: "Hryvnia",
    countries: ["Ukraine"],
  },
  UGX: {
    isoCode: "800",
    fractionDigit: 0,
    currencyName: "Uganda Shilling",
    countries: ["Uganda"],
  },
  USD: {
    isoCode: "840",
    fractionDigit: 2,
    symbol: "$",
    unicode: "U+00024",
    htmlCode: "&#x24;",
    hexCode: "&#36;",
    currencyName: "US Dollar",
    countries: [
      "American Samoa",
      "Bonaire, Sint Eustatius and Saba",
      "British Indian Ocean Territory (The)",
      "Ecuador",
      "El Salvador",
      "Guam",
      "Haiti",
      "Marshall Islands (The)",
      "Micronesia (Federated States Of)",
      "Northern Mariana Islands (The)",
      "Palau",
      "Panama",
      "Puerto Rico",
      "Timor-Leste",
      "Turks and Caicos Islands (The)",
      "United States Minor Outlying Islands (The)",
      "United States of America (The)",
      "Virgin Islands (British)",
      "Virgin Islands (U.S.)",
    ],
  },
  USN: {
    isoCode: "997",
    fractionDigit: 2,
    currencyName: "US Dollar (Next day)",
    countries: ["United States of America (The)"],
  },
  UYI: {
    isoCode: "940",
    fractionDigit: 0,
    currencyName: "Uruguay Peso en Unidades Indexadas (UI)",
    countries: ["Uruguay"],
  },
  UYU: {
    isoCode: "858",
    fractionDigit: 2,
    currencyName: "Peso Uruguayo",
    countries: ["Uruguay"],
  },
  UYW: {
    isoCode: "927",
    fractionDigit: 4,
    currencyName: "Unidad Previsional",
    countries: ["Uruguay"],
  },
  UZS: {
    isoCode: "860",
    fractionDigit: 2,
    currencyName: "Uzbekistan Sum",
    countries: ["Uzbekistan"],
  },
  VES: {
    isoCode: "928",
    fractionDigit: 2,
    currencyName: "Bolívar Soberano",
    countries: ["Venezuela (Bolivarian Republic Of)"],
  },
  VND: {
    isoCode: "704",
    fractionDigit: 0,
    currencyName: "Dong",
    countries: ["Viet Nam"],
  },
  VUV: {
    isoCode: "548",
    fractionDigit: 0,
    currencyName: "Vatu",
    countries: ["Vanuatu"],
  },
  WST: {
    isoCode: "882",
    fractionDigit: 2,
    currencyName: "Tala",
    countries: ["Samoa"],
  },
  XAF: {
    isoCode: "950",
    fractionDigit: 0,
    currencyName: "CFA Franc BEAC",
    countries: [
      "Cameroon",
      "Central African Republic (The)",
      "Chad",
      "Congo (The)",
      "Equatorial Guinea",
      "Gabon",
    ],
  },
  XAG: {
    isoCode: "961",
    fractionDigit: 0,
    currencyName: "Silver",
    countries: ["Zz11_silver"],
  },
  XAU: {
    isoCode: "959",
    fractionDigit: 0,
    currencyName: "Gold",
    countries: ["Zz08_gold"],
  },
  XBA: {
    isoCode: "955",
    fractionDigit: 0,
    currencyName: "Bond Markets Unit European Composite Unit (EURCO)",
    countries: ["Zz01_bond Markets Unit European_eurco"],
  },
  XBB: {
    isoCode: "956",
    fractionDigit: 0,
    currencyName: "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
    countries: ["Zz02_bond Markets Unit European_emu-6"],
  },
  XBC: {
    isoCode: "957",
    fractionDigit: 0,
    currencyName: "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
    countries: ["Zz03_bond Markets Unit European_eua-9"],
  },
  XBD: {
    isoCode: "958",
    fractionDigit: 0,
    currencyName: "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
    countries: ["Zz04_bond Markets Unit European_eua-17"],
  },
  XCD: {
    isoCode: "951",
    fractionDigit: 2,
    currencyName: "East Caribbean Dollar",
    countries: [
      "Anguilla",
      "Antigua and Barbuda",
      "Dominica",
      "Grenada",
      "Montserrat",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
    ],
  },
  XDR: {
    isoCode: "960",
    fractionDigit: 0,
    currencyName: "SDR (Special Drawing Right)",
    countries: ["International Monetary Fund (Imf) "],
  },
  XOF: {
    isoCode: "952",
    fractionDigit: 0,
    currencyName: "CFA Franc BCEAO",
    countries: [
      "Benin",
      "Burkina Faso",
      "Côte d'Ivoire",
      "Guinea-Bissau",
      "Mali",
      "Niger (The)",
      "Senegal",
      "Togo",
    ],
  },
  XPD: {
    isoCode: "964",
    fractionDigit: 0,
    currencyName: "Palladium",
    countries: ["Zz09_palladium"],
  },
  XPF: {
    isoCode: "953",
    fractionDigit: 0,
    currencyName: "CFP Franc",
    countries: ["French Polynesia", "New Caledonia", "Wallis and Futuna"],
  },
  XPT: {
    isoCode: "962",
    fractionDigit: 0,
    currencyName: "Platinum",
    countries: ["Zz10_platinum"],
  },
  XSU: {
    isoCode: "994",
    fractionDigit: 0,
    currencyName: "Sucre",
    countries: ['Sistema Unitario De Compensacion Regional De Pagos "Sucre"'],
  },
  XTS: {
    isoCode: "963",
    fractionDigit: 0,
    currencyName: "Codes specifically reserved for testing purposes",
    countries: ["Zz06_testing_code"],
  },
  XUA: {
    isoCode: "965",
    fractionDigit: 0,
    currencyName: "ADB Unit of Account",
    countries: ["Member Countries of the African Development Bank Group"],
  },
  XXX: {
    isoCode: "999",
    fractionDigit: 0,
    currencyName:
      "The codes assigned for transactions where no currency is involved",
    countries: ["Zz07_no_currency"],
  },
  YER: {
    isoCode: "886",
    fractionDigit: 2,
    currencyName: "Yemeni Rial",
    countries: ["Yemen"],
  },
  ZAR: {
    isoCode: "710",
    fractionDigit: 2,
    currencyName: "Rand",
    countries: ["Lesotho", "Namibia", "South Africa"],
  },
  ZMW: {
    isoCode: "967",
    fractionDigit: 2,
    currencyName: "Zambian Kwacha",
    countries: ["Zambia"],
  },
  ZWL: {
    isoCode: "932",
    fractionDigit: 2,
    currencyName: "Zimbabwe Dollar",
    countries: ["Zimbabwe"],
  },
};
